import { Box, Typography } from "@mui/material";
import React, { useRef } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getDrugList } from "../../../api/group";
import AddUserIcon from "../../../assets/SVG/addUserIcon";
import EyeIcon from "../../../assets/SVG/eyeIcon";
import PillIcon from "../../../assets/SVG/pillIcon";
import ErjaAdminPop from "../../../pages/leaderGroup/erjaAdminPop";
import SearchInput from "../../project/searchInput";
import DrugTable from "./drugTable";
import NewUser from "./newUser";

export default function DetailsDrug({ setMode, mode, notGroup }) {
  const [dataTable, setDataTable] = useState();
  const [valueSearch, setValueSearch] = useState();
  const [open, setOpen] = useState();
  const [openAdmin, setOpenAdmin] = useState();
  const gridRef = useRef();
  useEffect(() => {
    getDrugList()
      .then((x) => setDataTable(x))
      .catch(() => {});
  }, []);
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  return (
    <Box>
      <ErjaAdminPop drug open={openAdmin} setOpen={setOpenAdmin} />
      <NewUser open={open} setOpen={setOpen} />
      <Typography mb="20px" className="title_GroupOnline">
        {"انبار داروخانه"}
      </Typography>
      <Box mt="10px" display="flex" gap="10px">
        {!notGroup && (
          <Box display="flex" sx={{ cursor: "pointer" }} alignItems={"center"}>
            <AddUserIcon />
            <Typography
              fontWeight={"bold"}
              color="#4C8395"
              fontSize="16px"
              mr="10px"
              onClick={() => {
                setOpen(!open);
              }}
            >
              اختصاص به کاربر
            </Typography>
          </Box>
        )}
        <Typography color="white" fontSize="20px">
          |
        </Typography>
        <Box
          display="flex"
          onClick={() => setMode("new")}
          sx={{ cursor: "pointer" }}
          alignItems={"center"}
        >
          <PillIcon />
          <Typography
            fontWeight={"bold"}
            color="#4C8395"
            fontSize="16px"
            mr="10px"
          >
            دارو جدید
          </Typography>
        </Box>
        {!notGroup && (
          <>
            <Typography color="white" fontSize="20px">
              |
            </Typography>
            <Box
              display="flex"
              onClick={() => {
                setOpenAdmin(!openAdmin);
              }}
              sx={{ cursor: "pointer" }}
              alignItems={"center"}
            >
              <EyeIcon size="1.5" color="#4C8395" />
              <Typography
                fontWeight={"bold"}
                color="#4C8395"
                fontSize="16px"
                mr="10px"
              >
                مشاهده مسئول
              </Typography>
            </Box>
          </>
        )}
      </Box>
      <Box mt="20px"></Box>
      <SearchInput
        type="text"
        id="filter-text-box"
        onInput={onFilterTextBoxChanged}
        value={valueSearch}
        onChange={(e) => setValueSearch(e.target.value)}
        mb="5px"
        mr="20px"
      />
      <Box mt="20px"></Box>
      <DrugTable
        notGroup={notGroup}
        gridRef={gridRef}
        rowData={dataTable}
        setRowData={setDataTable}
      />
    </Box>
  );
}
